import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { pick, mapValues } from 'lodash-es';
import { isEmptyAddress } from 'platform/forms/address/helpers';
import { areAddressesEqual } from 'platform/user/profile/vap-svc/util';
import {
  FIELD_NAMES,
  USA,
  ADDRESS_PROPS,
} from 'platform/user/profile/vap-svc/constants';
import { selectVAPContactInfoField, selectEditedFormField } from '../selectors';

export const CopyMailingAddress = ({ copyMailingAddress }) => {
  const mailingAddress = useSelector(state =>
    selectVAPContactInfoField(state, FIELD_NAMES.MAILING_ADDRESS),
  );
  const residentialAddress = useSelector(
    state =>
      selectEditedFormField(state, FIELD_NAMES.RESIDENTIAL_ADDRESS).value,
  );
  const emptyMailingAddress = isEmptyAddress(mailingAddress);

  const areHomeMailingAddressesEqual = areAddressesEqual(
    mailingAddress,
    residentialAddress,
  );

  const onChange = () => {
    // If mailing + home addresses are the same, clear the home address
    if (areHomeMailingAddressesEqual) {
      const clearedHomeAddress = mapValues(mailingAddress, () => null);

      // We need the id to remain the same to prevent POST calls
      clearedHomeAddress.id = residentialAddress?.id || null;
      clearedHomeAddress.countryCodeIso3 = USA.COUNTRY_ISO3_CODE;

      copyMailingAddress(clearedHomeAddress);
      return;
    }

    // Otherwise, make the home address the same as the mailing address
    const copiedHomeAddress = pick(mailingAddress, ADDRESS_PROPS);
    copyMailingAddress(copiedHomeAddress);
  };

  if (emptyMailingAddress) {
    return <div />;
  }

  return (
    <div className="copy-mailing-address-to-residential-address">
      <div className="form-checkbox-buttons form-checkbox">
        <input
          checked={areHomeMailingAddressesEqual}
          id="copy-mailing-address-to-residential-address"
          name="copy-mailing-address-to-residential-address"
          onChange={onChange}
          type="checkbox"
        />
        <label htmlFor="copy-mailing-address-to-residential-address">
          Use my mailing address for my home address.
        </label>
      </div>
    </div>
  );
};

CopyMailingAddress.propTypes = {
  copyMailingAddress: PropTypes.func.isRequired,
};
